import polyline from "@mapbox/polyline";

const areaResolver = {
  Area: {
    decodedCoordinates: area => {
      if (area.map_coordinates.encoded_boundary) {
        const { coordinates } = polyline.toGeoJSON(
          area.map_coordinates.encoded_boundary
        );
        return [coordinates];
      }
      return null;
    },
    id: area => Number(area.id)
  }
};

export default areaResolver;
